var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"observerTarget"},[(_vm.isVisible)?_vm._t("content"):_vm._t("placeholder")],2)}
var staticRenderFns = []

export { render, staticRenderFns }